module.exports = __webpack_public_path__ + "img/technical-prevention-bg--disabled.7220a45f.png";